var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4H2V13H14V4ZM2 2C0.895431 2 0 2.89543 0 4V13C0 14.1046 0.895431 15 2 15H14C15.1046 15 16 14.1046 16 13V4C16 2.89543 15.1046 2 14 2H2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C3.44772 3 3 2.55228 3 2V1C3 0.447715 3.44772 2.41412e-08 4 0C4.55228 -2.41412e-08 5 0.447715 5 1V2C5 2.55228 4.55228 3 4 3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C11.4477 3 11 2.55228 11 2V1C11 0.447715 11.4477 2.41412e-08 12 0C12.5523 -2.41412e-08 13 0.447715 13 1V2C13 2.55228 12.5523 3 12 3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7C6 7.55228 5.55228 8 5 8C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6C5.55228 6 6 6.44772 6 7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C12 7.55228 11.5523 8 11 8C10.4477 8 10 7.55228 10 7C10 6.44772 10.4477 6 11 6C11.5523 6 12 6.44772 12 7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10C6 10.5523 5.55228 11 5 11C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9C5.55228 9 6 9.44772 6 10Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10C9 10.5523 8.55228 11 8 11C7.44772 11 7 10.5523 7 10C7 9.44772 7.44772 9 8 9C8.55228 9 9 9.44772 9 10Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C12 10.5523 11.5523 11 11 11C10.4477 11 10 10.5523 10 10C10 9.44772 10.4477 9 11 9C11.5523 9 12 9.44772 12 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f76820ec.svg";
export { ForwardRef as ReactComponent };